import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "kt_aside",
  class: "aside aside-hoverable aside-light",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "aside",
  "data-kt-drawer-activate": "{default: true, lg: false}",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
  "data-kt-drawer-direction": "start",
  "data-kt-drawer-toggle": "#kt_aside_mobile_toggle"
}
const _hoisted_2 = {
  class: "aside-logo flex-column-auto",
  id: "kt_aside_logo"
}
const _hoisted_3 = { href: "javascript:;" }
const _hoisted_4 = {
  id: "kt_aside_toggle",
  class: "btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle",
  "data-kt-toggle": "true",
  "data-kt-toggle-state": "active",
  "data-kt-toggle-target": "body",
  "data-kt-toggle-name": "aside-minimize"
}
const _hoisted_5 = { class: "svg-icon svg-icon-1 rotate-180" }
const _hoisted_6 = { class: "aside-menu flex-column-fluid" }
const _hoisted_7 = {
  class: "aside-footer flex-column-auto pt-0 pb-16 px-5",
  id: "kt_aside_footer"
}
const _hoisted_8 = {
  key: 0,
  class: "seq-aside-user"
}
const _hoisted_9 = { class: "seq-aside-user__avatar" }
const _hoisted_10 = { class: "flex-grow-1 overflow-hidden" }
const _hoisted_11 = { class: "seq-aside-user__name text-truncate" }
const _hoisted_12 = { class: "seq-aside-user__email text-truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_KTMenu = _resolveComponent("KTMenu")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("a", _hoisted_3, [
        _createVNode("img", {
          alt: "Logo",
          src: _ctx.lightLogo,
          class: "h-50px logo"
        }, null, 8, ["src"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Angle-double-left.svg" })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_KTMenu)
    ]),
    _createVNode("div", _hoisted_7, [
      (_ctx.user)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("img", {
                src: _ctx.user.avatar || 'media/avatars/blank.png',
                alt: "user"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.user.fname) + " " + _toDisplayString(_ctx.user.lname), 1),
              _createVNode("div", _hoisted_12, _toDisplayString(_ctx.user.email || _ctx.user.usid), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}